(function () {
  const flickityOpts = {
    cellAlign: 'left',
    contain: true,
    adaptiveHeight: true,
    autoPlay: 3000,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    draggable: true,
  };

  const play = (flkty) => {
    if (typeof flkty.playPlayer === 'function') flkty.playPlayer();
  };

  const refresh = (flkty) => {
    flkty.resize();
    flkty.reposition();
  };

  const bindDots = (flkty, stage) => {
    const dotsRoot = stage?.querySelector('[data-fcp-page-dots]');
    const dots = [...(dotsRoot?.querySelectorAll('.dot') ?? [])];
    if (!dots.length || !dotsRoot || !flkty) return;

    const sync = () => {
      dots.forEach((dot, i) => {
        const active = i === flkty.selectedIndex;
        dot.classList.toggle('is-selected', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    if (!flkty._fcpDotsBound) {
      flkty.on('select', sync);
      flkty.on('change', sync);
      flkty.on('settle', sync);
      flkty._fcpDotsBound = true;
    }

    sync();

    if (dotsRoot.dataset.fcpDotsClickBound) return;

    dotsRoot.addEventListener('click', (e) => {
      const dot = e.target.closest('.dot');
      const i = dots.indexOf(dot);
      if (i > -1) flkty.select(i);
    });

    dots.forEach((dot, i) => {
      dot.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          flkty.select(i);
        }
      });
    });

    dotsRoot.dataset.fcpDotsClickBound = 'true';
  };

  const createCarousel = (el) => {
    const stage = el.closest('[data-fcp-stage]');
    let flkty = typeof Flickity !== 'undefined' ? Flickity.data(el) : null;

    if (flkty && el.classList.contains('flickity-enabled')) {
      bindDots(flkty, stage);
      refresh(flkty);
      play(flkty);
      return flkty;
    }

    if (flkty) flkty.destroy();

    flkty = new Flickity(el, flickityOpts);
    bindDots(flkty, stage);

    flkty.on('ready', () => {
      refresh(flkty);
      play(flkty);
    });

    flkty.on('settle', () => play(flkty));

    el.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', () => refresh(flkty), { once: true });
    });

    refresh(flkty);
    play(flkty);
    return flkty;
  };

  const init = (root = document) => {
    if (typeof Flickity === 'undefined') return false;

    const carousels = root.querySelectorAll('[data-fcp-carousel]');
    if (!carousels.length) return false;

    carousels.forEach(createCarousel);
    return true;
  };

  const boot = (root) => {
    let attempts = 0;
    const run = () => {
      if (init(root)) return;
      if (++attempts < 60) window.setTimeout(run, 100);
    };
    run();
  };

  window.initFeaturedCollectionPromo = init;

  document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
